import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AuthImage({ path, alt = "", className = "", onClick }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url = null;
    let cancelled = false;
    if (!path) return;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((res) => {
        if (cancelled) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      })
      .catch(() => setSrc(null));
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [path]);
  if (!src) return <div className={`${className} bg-slate-100 animate-pulse`} />;
  return <img src={src} alt={alt} className={className} onClick={onClick} loading="lazy" />;
}
